module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel1"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel2"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Welcome!")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.forgot) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.forgot) ? _c('button', {
    staticClass: "btn btn-primary btn-block",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Sign In")]) : _c('button', {
    staticClass: "btn btn-primary btn-block",
    class: {
      loading: _vm.loading
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("\n        Reset password\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-block",
    on: {
      "click": function($event) {
        _vm.forgot = !_vm.forgot;
        _vm.error = ''
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.forgot ? 'Back' : 'Forgot password?') + "\n      ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "toast toast-error",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm._e(), _vm._v(" "), (_vm.msg) ? _c('div', {
    staticClass: "toast toast-success",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47a49b8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/login.vue
// module id = 495
// module chunks = 1